/* eslint-disable no-undef */
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useSelector, useDispatch } from "react-redux";

// components
import PopupSelect from "components/ui/popup/Select";

// redux
import "redux/slices/partner/partnerSlice";

// assets
import DownArrow from "assets/icons/down-arrow.svg";
import UpDownArrow from "assets/icons/up-down-arrow.svg";

const SelectBranch = ({ mode = "simple" }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { branchList, currentSelectedBranch } = useSelector(
    (state) => state.partner
  );

  const branchName =
    branchList.length > 0 && currentSelectedBranch
      ? branchList.find((el) => el.seqPartnerBranch === currentSelectedBranch)
          ?.branchName
      : "지점 선택";

  const makeOptionList = () => {
    let options = [];
    options = branchList?.map((branch) => ({
      value: branch.seqPartnerBranch,
      label: branch.branchName,
    }));
    return options;
  };

  const onChange = (name, value) => {
    dispatch(setCurrentSelectedBranch(value));
  };

  return (
    <PopupSelect
      title="지점을 선택해주세요"
      open={open}
      value={currentSelectedBranch}
      onChange={onChange}
      onClose={() => setOpen(false)}
      options={makeOptionList()}
      isBlock={true}
    >
      <Wrapper className={mode === "simple" ? "simple" : "complex"}>
        <CurrentCenterName>{branchName}</CurrentCenterName>
        <Icon src={mode === "simple" ? DownArrow : UpDownArrow} />
      </Wrapper>
    </PopupSelect>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.simple {
    p {
      font-weight: 700;
    }
    img {
      width: 25px;
      padding-left: 10px;
    }
  }

  &.complex {
    justify-content: space-between;
    background-color: #083ea9;
    padding: 16px 15px;
    height: 54px;
    border-radius: 12px;

    p {
      color: white;
    }
  }
`;

const CurrentCenterName = styled.p`
  font-family: Pretendard;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

const Icon = styled.img``;

export default SelectBranch;
